export const USER_SEEN_FLAG_PROPERTY_KEY = 'jsm.custom.domain.flag.seen.date';
export const PACKAGE_NAME = 'jiraHelpCenterCustomDomainChangeBoarding';
export const TEAM_NAME = 'jsm-banana';
export const FETCH_USER_PROPERTY_ERROR_ID = 'fetchUserProperty';
export const UPDATE_USER_PROPERTY_ERROR_ID = 'updateUserProperty';
export const GET_SHOW_FLAG_DATE_ERROR_ID = 'getShowFlagDate';
